
export default {
    name: "popup_reference",
    props: ["item"],
    data(){
        return {
            isLoading: false,

            email: null,
            selectedLang: "en",

            langText: {
                en: {
                    title: "Sharing wellness can be rewarding.",
                    subtitle: "Sharing wellness can be rewarding.",
                    desc_1: "Know a colleague who could benefit from MyWellness Fiesta? Invite them to join you!​",
                    desc_2: "Enter your colleague's OCBC Group e-mail address below and hit \“Invite!\”​",
                    desc_3: "An automated e-mail invitation will be sent to your colleague.",
                    desc_4: "When your colleague joins the event through your referral, you'll both receive 20 MyWellness Points!",
                    desc_5: "After all, wellness is better together. Our colleagues can be a great source of encouragement, helping each other build healthy habits and stay motivated along the way.",
                    input_label: "Referee's e-mail address",
                    btn_invite: "INVITE !",
                    disclaimer: "By submitting this information, I confirm that the person referred by me has consented to the collection, use, and disclosure of their email address by OCBC Group for the purposes of contacting them about the MyWellness Fiesta.",
                    disclaimer_2: "Note that colleagues without external e-mail access will still be able to receive referral and activation e-mails — so invite them anyway!",
                    error_invalid: "You have entered an invalid OCBC Group email address.",
                    error_exists: "This user is already registered."
                },
                cn: {
                    subtitle: "分享健康，赢取奖励。",
                    desc_1: "今年，我们要感谢那些通过活动帮助我们大力宣传的同事。毕竟，同事之间应当互相鼓励，养成好习惯，改掉坏习惯。",
                    desc_2: "系统会自动给他们发送一封邀请邮件。",
                    desc_3: "在下方填写您同事的华侨银行集团工作电邮地址，然后点击“邀请！”",
                    desc_4: "如果被推荐人通过您的推荐参加了本项活动，则您和被推荐人均可获得20个MyWellness积分！",
                    input_label: "被推荐人的电邮地址：",
                    btn_invite: "邀请！",
                    disclaimer: "提交此信息即表示我确认被推荐人同意让华侨银行集团收集、使用和公开他们的电邮地址，以便就健康嘉年华活动与其联系。",
                    disclaimer_2: "没有外发电子邮件权限的同事仍可接收推荐和激活邮件。请务必邀请他们参加！",
                    error_invalid: "您填写了一个错误的华侨银行电邮地址。",
                    error_exists: "该用户已注册！"
                },
            }
        }
    },
    computed: {
        
    },
    mounted(){

    },
    methods: {
        onClickSubmitBtn(){
            if(!this.isLoading){
                this.isLoading = true;

                this.onHandleTriggerAnalytics(`submit@reference`);

                this.$axios.$post("/referrer", { email: this.email }, this.tokenHeader).then((res) => {
                    console.log("submitReferrerCallback", res);

                    this.email = null;
                    this.isLoading = false;
                    this.$swal({ icon: "success", title: "Success!" });
                }).catch((err) => {
                    console.error("submitReferrerError", err);
                    this.isLoading = false;
                    if(err?.response?.data?.message == "You have entered an invalid OCBC Group email address."){
                        return this.$swal({ icon: "error", title: this.langText[this.selectedLang].error_invalid });
                    }else if(err?.response?.data?.message == "This user is already registered."){
                        return this.$swal({ icon: "error", title: this.langText[this.selectedLang].error_exists });
                    }
                    return this.onHandleApiError(err);
                });
            }
        },
        onClickCloseBtn(){
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@reference`);
        },
    },
    watch: {
        
    }
}
